import React, { useState } from 'react';
import toast from 'react-hot-toast';
import api from '../../services/api';
import { productReportsService } from '../../services/productReportsService';

const DailySalesReport = ({ locationId, selectedLocation }) => {
  const [dailySalesReport, setDailySalesReport] = useState(null);
  const [dailySalesLoading, setDailySalesLoading] = useState(false);
  const [dailySalesDate, setDailySalesDate] = useState(new Date().toISOString().split('T')[0]);

  const loadDailySalesReport = async () => {
    try {
      setDailySalesLoading(true);
      const response = await productReportsService.getDailySalesReport({
        date: dailySalesDate,
        location_id: locationId
      });
      setDailySalesReport(response.data || null);
    } catch (err) {
      console.error('Blad pobierania raportu dziennej sprzedazy:', err);
      setDailySalesReport(null);
    } finally {
      setDailySalesLoading(false);
    }
  };

  const printDailySalesReport = async () => {
    if (!dailySalesReport) return;
    const summary = dailySalesReport.summary || {};
    try {
      const params = new URLSearchParams({ date: summary.date || '' });
      if (locationId) params.append('location_id', locationId);
      const response = await api.get(`/reports/products/daily-sales/pdf?${params}`, { responseType: 'blob' });
      const url = URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
      window.open(url, '_blank');
    } catch {
      toast.error('Blad generowania PDF raportu sprzedazy.');
    }
  };

  return (
    <div>
      <div style={{ border: '1px solid var(--border)', borderRadius: '0.375rem', backgroundColor: 'var(--card-bg)' }}>
        <div style={{ padding: '0.5rem', backgroundColor: 'var(--bg)', borderBottom: '1px solid var(--border)' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '0.5rem' }}>
            <h5 style={{ margin: 0, fontSize: '0.9rem', fontWeight: '600' }}>📋 Lista sprzedanych produktów</h5>
            <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
              <input
                type="date"
                style={{
                  padding: '6px 10px',
                  fontSize: '12px',
                  border: '1px solid var(--border)',
                  borderRadius: '6px',
                  backgroundColor: 'var(--card-bg)',
                  color: 'var(--text)'
                }}
                value={dailySalesDate}
                onChange={(e) => setDailySalesDate(e.target.value)}
              />
              <button
                onClick={loadDailySalesReport}
                disabled={dailySalesLoading}
                style={{
                  padding: '6px 12px',
                  border: '1px solid var(--primary)', color: 'var(--primary)' ,
                  fontSize: '12px',
                  fontWeight: '500'
                }}
              >
                {dailySalesLoading ? '⏳' : '🔍'} Pokaż
              </button>
              {dailySalesReport && (
                <button
                  onClick={printDailySalesReport}
                  style={{
                    padding: '6px 12px',
                    border: '1px solid var(--success)', color: 'var(--success)' ,
                    fontSize: '12px',
                    fontWeight: '500'
                  }}
                >
                  🖨️ Drukuj
                </button>
              )}
            </div>
          </div>
        </div>
        <div style={{ padding: '0.75rem' }}>
          {dailySalesLoading ? (
            <div style={{ textAlign: 'center', padding: '2rem', color: 'var(--text-muted)' }}>
              ⏳ Ładowanie...
            </div>
          ) : dailySalesReport ? (
            <div>
              {/* Podsumowanie */}
              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(100px, 1fr))',
                gap: '0.5rem',
                marginBottom: '0.75rem',
                padding: '0.5rem',
                backgroundColor: 'var(--bg)',
                borderRadius: '4px'
              }}>
                <div style={{ textAlign: 'center' }}>
                  <div style={{ fontSize: '1rem', fontWeight: '600', color: 'var(--primary)' }}>
                    {dailySalesReport.summary?.total_items || 0}
                  </div>
                  <div style={{ fontSize: '0.65rem', color: 'var(--text-muted)' }}>Pozycji</div>
                </div>
                <div style={{ textAlign: 'center' }}>
                  <div style={{ fontSize: '1rem', fontWeight: '600', color: 'var(--info)' }}>
                    {(dailySalesReport.summary?.total_quantity || 0).toFixed(0)}
                  </div>
                  <div style={{ fontSize: '0.65rem', color: 'var(--text-muted)' }}>Sztuk</div>
                </div>
                <div style={{ textAlign: 'center' }}>
                  <div style={{ fontSize: '1rem', fontWeight: '600', color: 'var(--text-muted)' }}>
                    {(dailySalesReport.summary?.total_netto || 0).toFixed(2)} zł
                  </div>
                  <div style={{ fontSize: '0.65rem', color: 'var(--text-muted)' }}>Netto</div>
                </div>
                <div style={{ textAlign: 'center' }}>
                  <div style={{ fontSize: '1rem', fontWeight: '600', color: 'var(--text-secondary)' }}>
                    {(dailySalesReport.summary?.total_brutto || 0).toFixed(2)} zł
                  </div>
                  <div style={{ fontSize: '0.65rem', color: 'var(--text-muted)' }}>Brutto</div>
                </div>
                <div style={{ textAlign: 'center' }}>
                  <div style={{ fontSize: '1rem', fontWeight: '600', color: 'var(--orange)' }}>
                    {(dailySalesReport.summary?.total_koszt_zakupu || 0).toFixed(2)} zł
                  </div>
                  <div style={{ fontSize: '0.65rem', color: 'var(--text-muted)' }}>Koszt zakupu</div>
                </div>
                <div style={{ textAlign: 'center' }}>
                  <div style={{ fontSize: '1rem', fontWeight: '600', color: 'var(--success)' }}>
                    {(dailySalesReport.summary?.total_marza || 0).toFixed(2)} zł
                  </div>
                  <div style={{ fontSize: '0.65rem', color: 'var(--text-muted)' }}>Marża</div>
                </div>
                <div style={{ textAlign: 'center' }}>
                  <div style={{ fontSize: '1rem', fontWeight: '600', color: 'var(--success)' }}>
                    {(dailySalesReport.summary?.avg_marza_procent || 0).toFixed(1)}%
                  </div>
                  <div style={{ fontSize: '0.65rem', color: 'var(--text-muted)' }}>Śr. marża</div>
                </div>
              </div>

              {/* Tabela produktów */}
              {dailySalesReport.items && dailySalesReport.items.length > 0 ? (
                <div style={{ overflowX: 'auto' }}>
                  <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.7rem' }}>
                    <thead>
                      <tr style={{ backgroundColor: 'var(--bg)' }}>
                        <th style={{ padding: '0.4rem', borderBottom: '2px solid var(--border)', textAlign: 'left', whiteSpace: 'nowrap' }}>Godzina</th>
                        <th style={{ padding: '0.4rem', borderBottom: '2px solid var(--border)', textAlign: 'left', whiteSpace: 'nowrap' }}>Nr dokumentu</th>
                        <th style={{ padding: '0.4rem', borderBottom: '2px solid var(--border)', textAlign: 'left' }}>Produkt</th>
                        <th style={{ padding: '0.4rem', borderBottom: '2px solid var(--border)', textAlign: 'center' }}>Ilość</th>
                        <th style={{ padding: '0.4rem', borderBottom: '2px solid var(--border)', textAlign: 'right' }}>Cena netto</th>
                        <th style={{ padding: '0.4rem', borderBottom: '2px solid var(--border)', textAlign: 'right' }}>Cena brutto</th>
                        <th style={{ padding: '0.4rem', borderBottom: '2px solid var(--border)', textAlign: 'right' }}>Wartość netto</th>
                        <th style={{ padding: '0.4rem', borderBottom: '2px solid var(--border)', textAlign: 'right' }}>Wartość brutto</th>
                        <th style={{ padding: '0.4rem', borderBottom: '2px solid var(--border)', textAlign: 'right' }}>Koszt zakupu</th>
                        <th style={{ padding: '0.4rem', borderBottom: '2px solid var(--border)', textAlign: 'right' }}>Marża zł</th>
                        <th style={{ padding: '0.4rem', borderBottom: '2px solid var(--border)', textAlign: 'right' }}>Marża %</th>
                        <th style={{ padding: '0.4rem', borderBottom: '2px solid var(--border)', textAlign: 'right' }}>Rabat %</th>
                        <th style={{ padding: '0.4rem', borderBottom: '2px solid var(--border)', textAlign: 'right' }}>Rabat zł</th>
                      </tr>
                    </thead>
                    <tbody>
                      {dailySalesReport.items.map((item, index) => (
                        <tr key={item.pozycja_id} style={{ backgroundColor: index % 2 === 0 ? 'var(--card-bg)' : 'var(--bg)' }}>
                          <td style={{ padding: '0.35rem', borderBottom: '1px solid var(--border)', whiteSpace: 'nowrap' }}>
                            {item.czas_transakcji ? item.czas_transakcji.substring(0, 5) : '-'}
                          </td>
                          <td style={{ padding: '0.35rem', borderBottom: '1px solid var(--border)', whiteSpace: 'nowrap', color: 'var(--text-muted)' }}>
                            {item.numer_dokumentu || item.numer_paragonu || '-'}
                          </td>
                          <td style={{ padding: '0.35rem', borderBottom: '1px solid var(--border)' }}>
                            <div style={{ fontWeight: '500' }}>{item.nazwa_produktu}</div>
                            {item.kod_produktu && (
                              <div style={{ fontSize: '0.6rem', color: 'var(--text-muted)' }}>{item.kod_produktu}</div>
                            )}
                          </td>
                          <td style={{ padding: '0.35rem', borderBottom: '1px solid var(--border)', textAlign: 'center', fontWeight: '600' }}>
                            {parseFloat(item.ilosc).toFixed(0)}
                          </td>
                          <td style={{ padding: '0.35rem', borderBottom: '1px solid var(--border)', textAlign: 'right' }}>
                            {parseFloat(item.cena_netto).toFixed(2)}
                          </td>
                          <td style={{ padding: '0.35rem', borderBottom: '1px solid var(--border)', textAlign: 'right' }}>
                            {parseFloat(item.cena_brutto).toFixed(2)}
                          </td>
                          <td style={{ padding: '0.35rem', borderBottom: '1px solid var(--border)', textAlign: 'right' }}>
                            {parseFloat(item.wartosc_netto).toFixed(2)}
                          </td>
                          <td style={{ padding: '0.35rem', borderBottom: '1px solid var(--border)', textAlign: 'right', fontWeight: '500' }}>
                            {parseFloat(item.wartosc_brutto).toFixed(2)}
                          </td>
                          <td style={{ padding: '0.35rem', borderBottom: '1px solid var(--border)', textAlign: 'right', color: 'var(--orange)' }}>
                            {parseFloat(item.koszt_zakupu_netto).toFixed(2)}
                          </td>
                          <td style={{
                            padding: '0.35rem',
                            borderBottom: '1px solid var(--border)',
                            textAlign: 'right',
                            fontWeight: '600',
                            color: parseFloat(item.marza_kwota) >= 0 ? 'var(--success)' : 'var(--danger)'
                          }}>
                            {parseFloat(item.marza_kwota).toFixed(2)}
                          </td>
                          <td style={{
                            padding: '0.35rem',
                            borderBottom: '1px solid var(--border)',
                            textAlign: 'right',
                            fontWeight: '600',
                            color: parseFloat(item.marza_procent) >= 0 ? 'var(--success)' : 'var(--danger)'
                          }}>
                            {parseFloat(item.marza_procent).toFixed(1)}%
                          </td>
                          <td style={{
                            padding: '0.35rem',
                            borderBottom: '1px solid var(--border)',
                            textAlign: 'right',
                            color: parseFloat(item.rabat_procent || 0) > 0 ? 'var(--danger)' : 'var(--text-muted)'
                          }}>
                            {parseFloat(item.rabat_procent || 0) > 0 ? `${parseFloat(item.rabat_procent).toFixed(1)}%` : '-'}
                          </td>
                          <td style={{
                            padding: '0.35rem',
                            borderBottom: '1px solid var(--border)',
                            textAlign: 'right',
                            color: parseFloat(item.rabat_kwota || 0) > 0 ? 'var(--danger)' : 'var(--text-muted)'
                          }}>
                            {parseFloat(item.rabat_kwota || 0) > 0 ? parseFloat(item.rabat_kwota).toFixed(2) : '-'}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div style={{ textAlign: 'center', padding: '1.5rem', color: 'var(--text-muted)', fontSize: '0.85rem' }}>
                  Brak sprzedaży w wybranym dniu
                </div>
              )}
            </div>
          ) : (
            <div style={{ textAlign: 'center', padding: '2rem', color: 'var(--text-muted)', fontSize: '0.85rem' }}>
              Wybierz datę i kliknij "Pokaż" aby wyświetlić raport
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DailySalesReport;
